import type { KnownConfig } from '@/modules/config/types/known-config';
import deFlag from '@/modules/i18n/assets/flags/de-flag.svg?url';
import enFlag from '@/modules/i18n/assets/flags/en-flag.svg?url';
// import heFlag from '@/modules/i18n/assets/flags/he-flag.svg?url';
import type { PartialDeep } from 'type-fest';

const defaultConfig: PartialDeep<KnownConfig> = {
  app: {
    name: {
      __default__: 'TireCloud<wbr/>.One',
    },
    description: {
      en: 'TireCloud<wbr/>.One Chronicles: Pioneering Innovation in the Tire Industry. To digitalize the tire industry and providing a gateway for the tire importing industry is our goal!',
      de: 'TireCloud<wbr/>.One Chronicles: Pionierische Innovation in der Reifenindustrie. Um die Reifenindustrie digital zu gestalten und eine Gateway für die Reifenimportindustrie zu schaffen ist unser Ziel!',
      he: 'TireCloud<wbr/>.One Chronicles: פיתוח מרשימ בתעשיית הרכבים. לצורך יישום מסחרי בתעשיית הרכבים ולצורך שירות לעסקאות רכבים בעולם היא המטרה שלנו!',
    },
    clientTimezone: undefined,
    serverTimezone: 'UTC',
  },
  i18n: {
    languages: {
      en: {
        code: 'en',
        fullDisplayName: 'English',
        nativeDisplayName: 'English',
        shortDisplayName: 'En',
        dir: 'ltr',
        flagUrl: enFlag,
      },
      de: {
        code: 'de',
        fullDisplayName: 'German',
        nativeDisplayName: 'Deutsch',
        shortDisplayName: 'De',
        dir: 'ltr',
        flagUrl: deFlag,
      },
      // he: {
      //   code: 'he',
      //   fullDisplayName: 'Hebrew',
      //   nativeDisplayName: 'עברית',
      //   shortDisplayName: 'He',
      //   dir: 'rtl',
      //   flagUrl: heFlag,
      // },
    },
    defaultLanguage: 'en',
    fallbackLanguage: 'en',
  },
  api: {
    url: import.meta.env.REACT_APP_API_URL,
  },
  sentry: {
    enabled: true,
    dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  },
  matomo: {
    url: import.meta.env.REACT_APP_MATOMO_URL,
    siteId: import.meta.env.REACT_APP_MATOMO_SITE_ID,
    apiKey: import.meta.env.REACT_APP_MATOMO_API_KEY,
  },
  features: {
    auth: {
      useHttpOnlyCookies: false,
      enableTokenRefreshing: false,
      tokenExpirationCheckInterval: 30 * 60 * 1000, // 30 minutes
      accessTokenSoftExpirationThreshold: 5 * 24 * 60 * 60 * 1000, // 5 days
      refreshTokenSoftExpirationThreshold: 1 * 24 * 60 * 60 * 1000, // 1 day
    },
    userManagement: {
      enabled: true,
      canUpdateCredentials: true,
      canDisableUser: true,
      canDisableUserPromotions: true,
    },
    emailRecipientsSetting: {
      enabled: false,
    },
    importExportSettings: {
      enabled: false,
    },
    dashboardSettings: {
      enabled: false,
    },
    analytics: {
      enabled: false,
    },
  },
  misc: {
    dataTablePageSize: 10,
    defaultQueryStaleTime: 1000 * 60 * 5, // 5 minutes
    defaultQueryRetryCount: 3, // 3 times
    defaultMutationRetryCount: 3, // 3 times
  },
};

export default defaultConfig;
